import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { LAYOUT_CONFIG } from '@/lib/config/layout'
import { stringToSlug } from '@/lib/utils'
import Link from 'next/link'

export const FooterMenuMobile = () => {
  return (
    <Accordion type='single' collapsible className='w-full space-y-2'>
      {LAYOUT_CONFIG.FOOTER.menuMobile.map((menu) => (
        <AccordionItem
          value={menu.title}
          className='space-y-1 border-0'
          key={menu.title}
        >
          <AccordionTrigger
            className='py-0 font-sans text-sm font-semibold leading-7 tracking-[3%] text-light'
            hasPlusIcon
            aria-label={`Mở menu ${menu.title}`}
          >
            {menu.title}
          </AccordionTrigger>
          <AccordionContent className='space-y-1.5'>
            {menu.items.map((item) => {
              const isExternal = item.url.startsWith('http')
              return (
                <Link
                  key={item.url}
                  href={item.url}
                  className='inline-block w-full text-xs leading-5 text-neutral-300'
                  target={isExternal ? '_blank' : undefined}
                  rel={isExternal ? 'noopener noreferrer' : undefined}
                  data-tracking-level-3={stringToSlug(item.label)}
                  prefetch={false}
                >
                  {item.label}
                </Link>
              )
            })}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  )
}
